import React, { useState, useEffect } from 'react'
import { Dropdown, Container, Image } from 'react-bootstrap'
import { CLASSES } from '../../../assets/styles/classes'
import PlusIcon from '../../../assets/icons/common/plus-white.svg'
import UserIcon from '../../../assets/icons/sidebar/users-1.svg'
import Table from '../../../components/table/Table'
import { useDispatch, useSelector } from 'react-redux'
import getPaginationData from '../../../store/actions/pagination'
import SearchFilter from '../../../components/extras/SearchFilter'
import { useNavigate } from 'react-router-dom'
import ActionElements from '../../../components/extras/ActionElements'
import { PAGINATION_TYPES } from '../../../utils/constants'
import { CustomerService } from '../../../services'
import { setCurrentPage } from '../../../store/reducers'
import { addOrUpdatePaginationData } from '../../../store/actions/pagination'
import REST_API from '../../../services/API_Routes'
import ButtonWithIcon from '../../../components/common/ButtonWithIcon'
import { preConfirmAlert } from '../../../utils/helperFunctions'

// Define DropDownItems as a separate functional component
const DropDownItems = ({ itemId, navigate }) => {
  return (
    <Dropdown.Item
      onClick={() => navigate(`/customer/details`, { state: { id: itemId } })}
      eventKey={itemId}
    >
      Details
    </Dropdown.Item>
  )
}

const columns = (navigate, deleteClick) => [
  {
    name: 'Customer Id',
    minWidth: '200px',
    style: { fontWeight: 'bold' },
    cell: ({ customer_id }) => (
      <div
        title={customer_id}
        style={{
          // maxWidth: '200px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {customer_id || '—'}
      </div>
    ),
  },
  {
    name: 'Customer Name',
    minWidth: '180px',
    cell: ({ customer_first_name }) => customer_first_name,
  },
  {
    name: 'Phone Number',
    minWidth: '160px',
    // maxWidth: '260px',
    cell: ({ customer_phone1 }) => customer_phone1 || '—',
  },
  {
    name: 'Email',
    minWidth: '130px',
    // maxWidth: '250px',
    cell: ({ customer_email_1 }) => (
      <div
        title={customer_email_1}
        style={{
          // maxWidth: '200px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {customer_email_1 || '—'}
      </div>
    ),
  },
  {
    name: 'Actions',
    width: '140px',
    center: true,
    cell: ({ customer_id }) => (
      <ActionElements
        id={customer_id || 1}
        editClick={() => navigate(`/customer/edit/${customer_id}`)}
        deleteClick={() => deleteClick(customer_id)} // Pass as a function reference
        viewClick={() =>
          navigate(`/customer/details`, { state: { id: customer_id } })
        }
        // dropdownItems={
        //   <DropDownItems itemId={row.customer_id} navigate={navigate} />
        // }
      />
    ),
  },
]

export default function Customer() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { items, currentPage, rowsPerPage, total } = useSelector(
    ({ pagination }) => pagination[PAGINATION_TYPES.CUSTOMERS],
  )
  const isLoading = useSelector(
    ({ loader }) => loader[PAGINATION_TYPES.CUSTOMERS],
  )
  const [searchQuery, setSearchQuery] = useState({})

  useEffect(() => {
    dispatch(
      getPaginationData({
        key: PAGINATION_TYPES.CUSTOMERS,
        ServiceName: CustomerService,
        page: currentPage,
        per_page: rowsPerPage,
        ...searchQuery,
      }),
    )
  }, [currentPage, rowsPerPage, searchQuery])

  const handleSearch = (query) => {
    setSearchQuery(query)
    dispatch(
      setCurrentPage({
        key: PAGINATION_TYPES.CUSTOMERS,
        currentPage: 1,
      }),
    )
  }

  const deleteClick = async (id) => {
    const { isConfirmed } = await preConfirmAlert({
      title: 'Are you sure to delete?',
      text: "This will deactivate the customer's account. You won't be able to revert this!",
      confirmButtonText: 'Yes, Deactivate it',
      denyButtonText: 'No',
      confirmButton: 'btn btn-danger px-5',
      denyButton: 'btn btn-primary ms-3 px-5',
    })
    if (isConfirmed) {
      dispatch(
        addOrUpdatePaginationData({
          id,
          key: PAGINATION_TYPES.CUSTOMERS,
          ServiceName: CustomerService,
          primaryKey: 'customer_id',
          route: REST_API.CUSTOMER_DELETE + id,
          value: { customer_active: 0 },
        }),
      )
    }
  }

  return (
    <Container fluid className='p-4 py-2 mt-2'>
      <div>
        <div className={CLASSES.content_between + 'flex-wrap gap-3'}>
          <h4 className={CLASSES.items_center + 'mb-0'}>
            <Image src={UserIcon} className='me-3' /> All Customers
          </h4>
          <div className={CLASSES.items_center + ' text-bold'}>
            Total Customer: {total}
          </div>
        </div>

        <div className='mb-5 mt-3 pt-4 border-radius-10 black-shadow-15'>
          <div
            className={CLASSES.content_between + ' px-4 mb-4 gap-3 flex-wrap'}
          >
            <ButtonWithIcon
              onClick={() => navigate('/customer/create')}
              className={'border-0'}
              label='Add New Customer'
              icon={PlusIcon}
            />
            <div className={CLASSES.content_end}>
              <SearchFilter
                handleSearch={handleSearch}
                placeholder='Customer Name'
              />
            </div>
          </div>

          <Table
            columns={columns(navigate, deleteClick)} // Pass deleteClick here
            data={items}
            progressPending={isLoading}
            paginationType={PAGINATION_TYPES.CUSTOMERS}
            customStyle={{
              rows: {
                style: {
                  borderTop: '0px solid #E0E0E0',
                  borderBottom: '1px solid #E0E0E0 !important',
                  display: 'flex !important',
                  alignItems: 'center !important',
                  padding: 5,
                },
              },
            }}
            conditionalRowStyles={[
              {
                when: ({ customer_active }) => customer_active == 0,
                style: {
                  backgroundColor: '#FFB0B0',
                },
              },
            ]}
          />
        </div>
      </div>
    </Container>
  )
}
